import Radio from "backbone.radio";

import FilterButtons from "./filter";
import ActionButtons from "./action";
import ButtonModel from "../../../models/button";
import filterButtonsConfig from "../../../config/report-buttons/filter";
import actionButtonsConfig from "../../../config/report-buttons/action";

const channel = Radio.channel("global");

const Mixin = (superclass) =>
  class extends superclass {
    addButtons(data) {
      // make sure the context exists
      if (this.getRegion) {
        const meta = data.model.get("meta");

        // pull filter data from result
        const filterData = meta.get("filter") || [];
        const groupData = meta.get("groupBy") || [];
        const buttonsData = [];

        // add filter data to config object when it exists
        if (filterData && filterData.length) {
          buttonsData.push(
            new ButtonModel({
              action: "filters",
              data: {
                data: filterData,
              },
            })
          );
        }

        // add group-by data to config object when it exists
        if (groupData && groupData.length) {
          buttonsData.push(
            new ButtonModel({
              action: "group-by",
              data: {
                data: groupData,
                formParamName: meta.get("groupableParameterName") || null,
              },
            })
          );
        }

        // CONFIG FILTERS
        const filtersConfig = {
          updatedFilterEventName: this.filtersUpdatedEvent,
          buttons: filterButtonsConfig,
          buttonsData,
        };

        // get region
        const filtersRegion = this.getRegion("filters");
        if (filtersRegion) {
          // render view
          filtersRegion.show(new FilterButtons(filtersConfig));
        } else {
          // announce config
          // console.log("announcing filters config", filtersConfig);
          channel.trigger("view-header:filters", filtersConfig);
        }

        // action buttons datasource and className rules
        const actionButtonRules = {
          customize: {
            // override action when in a drilldown
            eventName: this.options.activeRegion
              ? `${this.model.get("route")}.customize-view`
              : "customize-view",
            className:
              this.reportConfig && this.reportConfig.customColumns
                ? "btn btn-sm btn-emphasized"
                : "btn btn-sm btn-standard",
          },
          export: {
            datasource: meta.has("export") ? this.model.get("route") : "",
          },
        };

        // configure action buttons
        _.each(actionButtonsConfig, (config) => {
          const overrides = actionButtonRules[config.action];
          if (overrides) {
            Object.assign(config, overrides);
          }
        });

        // CONFIG ACTION BUTTONS
        const actionsConfig = {
          updatedFilterEventName: this.filtersUpdatedEvent,
          buttons: actionButtonsConfig,
          meta: {
            route: this.model.get("route"),
          },
        };

        // get region
        const actionsRegion = this.getRegion("actions");
        if (actionsRegion) {
          // render view
          actionsRegion.show(new ActionButtons(actionsConfig));
        } else {
          // announce config
          // console.log("announcing actions config", actionsConfig);
          channel.trigger("view-header:actions", actionsConfig);
        }

        // call superclass if necessary
        // if (super.addButtons) super.addButtons(data);
      }
    }
  };

export { Mixin as default };
